import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { EstablishmentUnblockValidationSchema } from "../schemas/blockUnblockEstablishment.schema";

interface UseUnblockEstablishmentProps {
  establishmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useUnblockEstablishment = ({ establishmentId, onSuccess, onError }: UseUnblockEstablishmentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, EstablishmentUnblockValidationSchema>({
    mutationKey: ['unblockEstablishment', establishmentId],
    mutationFn: (data) => privateAxios.put(`/establishment/companies/${establishmentId}/unblock`, {
      company: {
        reason: data.unblock_reason,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useUnblockEstablishment;
